/* import __COLOCATED_TEMPLATE__ from './template-inserter.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
let TemplateInserter = (_class = class TemplateInserter extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isExpanded", _descriptor, this);
  }
  get isVisible() {
    return this.args.composer.state?.hoverInfo?.editorHovered && this.args.composer.state?.selectionIsEmpty && !this.args.composer.state?.isEditing && !(this.args.composer.config.singleBlockMode && this.args.composer.state?.hasConditionalBlocks) && !this.args.composer.state?.selectionIsLayout;
  }
  expand() {
    this.isExpanded = true;
  }
  close() {
    this.isExpanded = false;
  }
  insert(attributePath) {
    this.isExpanded = false;
    let prosemirrorState = this.args.composer.state.prosemirrorState;
    if (prosemirrorState) {
      let templateSpec = prosemirrorState.schema.nodes.template;
      let pos = prosemirrorState.selection.from;
      let tr = prosemirrorState.tr;
      let node = templateSpec.createAndFill({
        attributePath,
        fallback: ''
      });
      if (node) {
        tr.insert(pos, node);
      }
      this.args.composer.commands.dispatch(tr);
      this.args.composer.commands.focus();
    }
  }
  onDocumentClick(e) {
    let element = e.target;
    do {
      if (element.classList.contains('embercom-prosemirror-template-inserter-opener') || element.classList.contains('embercom-prosemirror-template-inserter')) {
        return;
      }
    } while (element = element.parentElement);
    this.close();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "expand", [action], Object.getOwnPropertyDescriptor(_class.prototype, "expand"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDocumentClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDocumentClick"), _class.prototype), _class);
export { TemplateInserter as default };